/* Installation training shares the Sales Vault email unlock and lead capture. */
(function (root) {
  'use strict';
  var document = root.document;
  var gate = document.getElementById('installGate');
  var form = document.getElementById('installForm');
  var email = document.getElementById('installEmail');
  var lessons = document.getElementById('installLessons');
  if (!gate || !form || !email || !lessons) return;

  var KEY = 'ip_vault_unlock';
  var SOURCE = 'IronPeak Installation Training';
  var opened = false;
  // Storage can be unavailable in a private browser; access still works this visit.
  var storage = {
    getItem: function (key) { try { return root.localStorage.getItem(key); } catch (e) { return null; } },
    setItem: function (key, value) { try { root.localStorage.setItem(key, value); } catch (e) {} }
  };
  var known;
  try { known = JSON.parse(storage.getItem('ip_lead') || 'null'); } catch (e) { known = null; }

  function save(em) {
    storage.setItem(KEY, '1');
    if (em) storage.setItem('ip_lead', JSON.stringify({ email: em, ts: Date.now() }));
  }

  function record(em, name) {
    if (root.IPLeadCapture && em) {
      root.IPLeadCapture.reportSource({ email: em, name: name || '', source: SOURCE, storage: storage });
    }
  }

  function unlock(moveFocus) {
    if (opened) return;
    opened = true;
    lessons.hidden = false;
    gate.hidden = true;
    document.getElementById('installPreview').hidden = true;
    lessons.querySelectorAll('video[data-video-src]').forEach(function (video) {
      var card = video.closest('article');
      var status = card.querySelector('[data-video-status]');
      video.addEventListener('error', function () { status.hidden = false; });
      video.src = video.dataset.videoSrc;
      video.poster = video.dataset.poster;
      video.querySelectorAll('track[data-src]').forEach(function (track) { track.src = track.dataset.src; });
      card.querySelector('[data-video-link]').href = video.dataset.videoSrc;
      video.load();
    });
    if (moveFocus) document.getElementById('installLessonsTitle').focus();
  }

  var customer = root.IP_CUSTOMER;
  if (customer && customer.email) {
    save(customer.email);
    unlock(false);
    record(customer.email, customer.name);
  } else if (storage.getItem(KEY) === '1') {
    unlock(false);
    if (known && known.email) record(known.email);
  } else if (known && known.email) {
    email.value = known.email;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    email.value = email.value.trim();
    if (!email.checkValidity()) { email.reportValidity(); return; }
    save(email.value);
    unlock(true);
    record(email.value);
    if (root.IPLeadCapture) {
      root.IPLeadCapture.postJson({
        url: 'https://api.hsforms.com/submissions/v3/integration/submit/246087675/227f991a-f1ea-478d-992f-c1b4efcf4959',
        payload: { fields: [{ name: 'email', value: email.value }], context: { pageName: SOURCE } }
      })['catch'](function (error) {
        root.console.warn('[IronPeak installation training] HubSpot backstop failed', {
          timestamp: new Date().toISOString(), source: SOURCE, expected: '2xx', actual: error.message
        });
      });
    }
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
